import React from "react";
import { SoonLogo } from "../../components/soon";

const ComingSoon = (isPage=true) => {
  return (
    <div className={`comming-soon-page d-flex ${!isPage ?'h-100' : 'full-height'} flex-column align-items-center justify-content-center`}>
      <div className="coming-soon-wrapper">
        <SoonLogo />
        <h2 className="mt-3 f-800 color-primary">Coming soon !</h2>
      </div>
    </div>
  );
};

export default ComingSoon;
